export default {
  memberWifiStatusDetails__ACTIVE: "Active",
  memberWifiStatusDetails__BROWSE: "Browse the web",
  memberWifiStatusDetails__GET_CONNECTED: "Get connected to WiFi",
  memberWifiStatusDetails__RAPID_REWARDS: "Rapid Rewards<sup>®</sup> Member",
  memberWifiStatusDetails__WELCOME: "Welcome Jetsetter",
};
